/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const MedicalFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 24 24">
    <path fillRule="evenodd" clipRule="evenodd" d="M15.6842 3C15.6842 2.44772 15.2365 2 14.6842 2H9.31579C8.7635 2 8.31579 2.44772 8.31579 3L8.31579 8.31579H3C2.44772 8.31579 2 8.7635 2 9.31579V14.6842C2 15.2365 2.44772 15.6842 3 15.6842H8.31579L8.31579 21C8.31579 21.5523 8.7635 22 9.31579 22H14.6842C15.2365 22 15.6842 21.5523 15.6842 21V15.6842H21C21.5523 15.6842 22 15.2365 22 14.6842V9.31579C22 8.7635 21.5523 8.31579 21 8.31579H15.6842V3Z" fill="#242425" />
  </BaseSvgIcon>
)

export default MedicalFill
